/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

/**
 * プラン種別
 */
export type TenantPlanTypeSchema = (typeof TenantPlanTypeSchema)[keyof typeof TenantPlanTypeSchema];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TenantPlanTypeSchema = {
  free_lite: 'free_lite',
  free: 'free',
  paid: 'paid',
} as const;
